import routeTypes from './RouteTypes'

const ImageUploader = () => import(/* webpackChunkName: "signin-chunk" */ './ImageUploader.vue')

export default [
  {
    path: routeTypes.ImageUploader.path,
    name: routeTypes.ImageUploader.name,
    component: ImageUploader,
    meta: {
      id: '',
      route: 'listing',
      title: 'FlexiQuote Image Uploader'
    }
  }
]

